import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function AICareerAdvisor() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
  if (auth.currentUser) {
    navigate("/");
  } else {
    navigate("/get-started");
  }
};

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="AI Career Advisor"
        description="Get personalized career advice using AI. Discover career paths, improve job decisions, and build a plan for success with EmployPilot."
        canonical="https://employpilot.com/ai-career-advisor"
      />

      <h1>AI Career Advisor That Helps You Find the Right Path</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Not sure what career path to take? Our AI Career Advisor helps you
        explore options, make smarter decisions, and move forward with confidence.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
  Get instant career direction in seconds — no guesswork, no confusion.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Get Career Guidance
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Why Use an AI Career Advisor?</h2>

      <ul>
        <li>✔ Personalized career suggestions</li>
        <li>✔ Identify strengths and opportunities</li>
        <li>✔ Explore new industries and roles</li>
        <li>✔ Make smarter career decisions</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How It Works</h2>

      <h2 style={{ marginTop: "40px" }}>
  What Can an AI Career Advisor Help You With?
</h2>

<p>
  An AI career advisor goes beyond basic advice. It helps you analyze your skills,
  identify opportunities, and create a clear direction based on your goals.
</p>

<ul>
  <li>Discover high-demand career paths</li>
  <li>Understand which skills to develop next</li>
  <li>Get personalized job recommendations</li>
  <li>Plan your next career move with confidence</li>
</ul>

      <ol>
        <li>Tell us your experience and interests</li>
        <li>Receive AI-powered career insights</li>
        <li>Explore recommended roles</li>
        <li>Take action with a clear plan</li>
      </ol>

      {/* 🔥 INTERNAL LINKS (CRITICAL) */}
      <p style={{ marginTop: "20px" }}>
        Ready to build your resume?{" "}
        <Link to="/ai-resume-builder">
          Use our AI Resume Builder
        </Link>
      </p>

      <p>
        Want to prepare for interviews?{" "}
        <Link to="/ai-interview-coach">
          Practice with the AI Interview Coach
        </Link>
      </p>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>
        Take Control of Your Career Today
      </h2>

      <p>
        Whether you're starting fresh, switching careers, or trying to grow,
        EmployPilot gives you the tools and insights to move forward with clarity.
      </p>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Start Your Career Journey</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Get Started Free
        </button>
      </div>
    <h2 style={{ marginTop: "40px" }}>
      Frequently Asked Questions
    </h2>

      <h3>Is AI career advice accurate?</h3>
      <p>
      AI career advisors use data and patterns to provide guidance, but your personal
      goals and decisions always matter most.
      </p>

      <h3>Can AI help me choose a career?</h3>
      <p>
       Yes. AI can analyze your experience, interests, and market trends to suggest
       realistic and achievable career paths.
      </p>

      <h3>Is this free to use?</h3>
      <p>
      EmployPilot offers free access with optional upgrades for advanced tools and
      unlimited usage.
      </p>
     
<p style={{ marginTop: "30px" }}>
  Want real advice from others?{" "}
  <strong>Join the EmployPilot Community</strong> to ask questions, get feedback,
  and learn from real job seekers.
</p>

<p style={{ fontSize: "14px", color: "#777" }}>
  (Free account required)
</p>

<Link to="/community">
  Explore the Community
</Link>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default AICareerAdvisor;